import React, { useState, useEffect, useRef } from 'react';
import config from '../../config';
import { Link, useNavigate, useLocation, NavLink } from 'react-router-dom';
import { LuClock, LuBookLock } from "react-icons/lu";
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import '../../assets/css/Navbar.css'
import axios from 'axios';
import { Badge, Dropdown, DropdownButton } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext'
import {
    FiHome,
    FiLogOut,
    FiUsers,
    FiFolder,
    FiCalendar,
    FiTrello,
    FiBriefcase,
    FiTag,
    FiInbox,
    FiUserCheck
} from 'react-icons/fi';

import { GrDocumentUser, GrServices } from "react-icons/gr";
import { BiCog, BiUserMinus } from 'react-icons/bi';
import { MdPolicy } from "react-icons/md";
import { MdOutlineHolidayVillage } from "react-icons/md";
import {
    IoToggleOutline,
    IoToggleSharp,
    IoPersonOutline,
    IoTicketOutline
} from 'react-icons/io5';
import { GiSecretBook } from "react-icons/gi";
import {
    RiFolderDownloadLine,
    RiFolderAddLine,
    RiCalendarEventLine,
    RiDownloadCloud2Fill,
    RiMailSendLine,
    RiSecurePaymentLine
} from "react-icons/ri";
import {
    TbLayoutBoardSplit,
    TbPlus,
    TbMinus,
    TbReportSearch,
    TbListNumbers,
    TbSubtask,
    TbReceiptRupee,
    TbTemplate,
    TbLinkPlus,
    TbInputX,
    TbDatabaseShare
} from "react-icons/tb";
import { VscReferences } from "react-icons/vsc";
import moment from 'moment';
import { Button } from 'primereact/button';
import { PiNyTimesLogo, PiInvoice, PiListNumbersBold, PiCallBell, PiListMagnifyingGlassBold } from "react-icons/pi";
import { TfiPrinter } from "react-icons/tfi";
import { LuBell, LuReceiptIndianRupee } from "react-icons/lu";
import { VscBellDot } from "react-icons/vsc";
import { HiOutlineUsers, HiOutlineWallet } from "react-icons/hi2";
import graphelogo from '../../assets/images/logogf.png';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { FaHandsHelping } from "react-icons/fa";
import { LiaFileInvoiceDollarSolid, LiaSwatchbookSolid } from "react-icons/lia";
import { FaUserTie } from "react-icons/fa6";
import { SiReaddotcv, SiBrandfolder } from "react-icons/si";
import { Dialog } from 'primereact/dialog';
import { GiFamilyTree } from "react-icons/gi";
import { getSocket } from '../../context/socket'; // adjust path as needed 

const Navbar = () => {
    const { isAuthenticated, role, logout, username, userId, accessToken, permissions } = useAuth();
    const socket = getSocket();
    const [notifications, setNotifications] = useState([]);
    // const notificationToastRef = useRef(null);
    const [menuCollapse, setMenuCollapse] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userDetails, setUserDetails] = useState({});
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const [isSubmenuOpen2, setIsSubmenuOpen2] = useState(false);
    const [isSubmenuOpen3, setIsSubmenuOpen3] = useState(false);
    const [isSubmenuOpen4, setIsSubmenuOpen4] = useState(false);
    const [isSubmenuOpen5, setIsSubmenuOpen5] = useState(false);
    const [isSubmenuOpen6, setIsSubmenuOpen6] = useState(false);
    const [isSubmenuOpen7, setIsSubmenuOpen7] = useState(false);
    const [isSubmenuOpen8, setIsSubmenuOpen8] = useState(false);
    const [isSubmenuOpen9, setIsSubmenuOpen9] = useState(false);
    const [profileImageUrl, setProfileImageUrl] = useState(null);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [checkedIn, setCheckedIn] = useState(false);
    const location = useLocation(); // Get the current URL path
    const [eventStatus, setEventStatus] = useState(null);
    // Check if the current path starts with a base path
    const isActive = (path) => location.pathname.startsWith(path);
    const menuIconClick = () => {
        setMenuCollapse(!menuCollapse);
    };

    const toggleSubmenu = () => {
        setIsSubmenuOpen(!isSubmenuOpen);
    };

    const toggleSubmenu2 = () => {
        setIsSubmenuOpen2(!isSubmenuOpen2);
    };
    const toggleSubmenu3 = () => {
        setIsSubmenuOpen3(!isSubmenuOpen3);
    };
    const toggleSubmenu4 = () => {
        setIsSubmenuOpen4(!isSubmenuOpen4);
    };
    const toggleSubmenu5 = () => {
        setIsSubmenuOpen5(!isSubmenuOpen5);
    };
    const toggleSubmenu6 = () => {
        setIsSubmenuOpen6(!isSubmenuOpen6);
    };
    const toggleSubmenu7 = () => {
        setIsSubmenuOpen7(!isSubmenuOpen7);
    };
    const toggleSubmenu8 = () => {
        setIsSubmenuOpen8(!isSubmenuOpen8);
    };
    const toggleSubmenu9 = () => {
        setIsSubmenuOpen9(!isSubmenuOpen9);
    };
    const [isCareersOpen, setIsCareersOpen] = useState(false);
    const hasPermission = (key) => Array.isArray(permissions) && permissions.includes(key);
    const handleLogout = () => {
        logout();
        navigate('/Graphe/login');
    };

    const viewprofile = () => {
        navigate('/Graphe/dashboard/profiledetails');
    };


    const viewticket = () => {
        navigate('/Graphe/dashboard/employee_ticket_list');
    };


    const fetchEventStatus = () => {
        setLoading(true); // ⏳ start

        socket.emit("fetchEventStatus");

        socket.once("eventStatus", (data) => {
            setEventStatus(data.status);
            setLoading(false); // ✅ end
        });
    };


    useEffect(() => {
        if (!socket) return;

        // --- Fetch event status when screen loads ---
        fetchEventStatus();

        // 🔁 Re-fetch on backend update
        socket.on("santaEventUpdated", () => {
            console.log("Santa Updated received — refetching...");
            fetchEventStatus();
        });

        return () => {
            socket.off("santaEventUpdated");
            socket.off("eventStatus");

        };
    }, [socket]);


    useEffect(() => {
        const fetchProfileImage = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/profile-image/profile-image/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });


                // Assuming response.data is an array and you want the first item
                const imgUrl = response.data.imageUrl; // Extract img_url from the response
                setProfileImageUrl(imgUrl);


            } catch (error) {
                console.error('Error fetching profile image:', error);
                // Handle error as needed
            }
        };

        fetchProfileImage();
    }, [userId, accessToken]); // Include userId and accessToken in dependency array

    const [hasUnread, setHasUnread] = useState(false);


    // Function to fetch unread notifications status
    const fetchUnreadStatus = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/notificationRoutes/notifications/unread/today/${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            setHasUnread(response.data.hasUnread);
        } catch (error) {
            console.error('Error fetching unread notification status:', error);
        }
    };

    // Fetch unread status on component mount
    useEffect(() => {
        if (userId && accessToken) {
            // Fetch immediately on mount
            fetchUnreadStatus();

            // Set up polling every 30 seconds
            const intervalId = setInterval(() => {
                fetchUnreadStatus();
            }, 30000);

            // Cleanup on component unmount
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [userId, accessToken]);



    // Function to request notification permission
    const requestNotificationPermission = () => {
        if (Notification.permission !== 'granted') {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    console.log('Notification permission granted.');
                }
            });
        }
    };

    // Show browser notification
    const showBrowserNotification = (notification) => {
        if ('Notification' in window && Notification.permission === 'granted') {
            const browserNotification = new Notification(notification.notification_type, {
                body: `${notification.message}\n ${new Intl.DateTimeFormat('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                }).format(new Date(notification.created_at))}`,
                icon: graphelogo,
            });

            browserNotification.onclick = () => {
                window.focus();
                browserNotification.close();
            };
        }
    };

    // Show notifications with delay
    const showNotificationsWithDelay = (notifications) => {
        if ('Notification' in window && Notification.permission === 'granted') {
            notifications.forEach((notification, index) => {
                setTimeout(() => {
                    showBrowserNotification(notification);
                }, index * 3000);
            });
        }
    };

    // Fetch notifications
    const fetchNotifications = async () => {
        try {
            const response = await fetch(`${config.apiBASEURL}/notificationRoutes/notifications_push/${userId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch notifications');
            }

            const data = await response.json();

            // Show notifications with delay
            showNotificationsWithDelay(data.notifications);

            // Update state
            setNotifications((prev) => [...prev, ...data.notifications]);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    // Handle permission request on first user interaction
    useEffect(() => {
        const handleUserInteraction = () => {
            requestNotificationPermission();
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('scroll', handleUserInteraction);
            document.removeEventListener('keypress', handleUserInteraction);
        };

        document.addEventListener('click', handleUserInteraction);
        document.addEventListener('scroll', handleUserInteraction);
        document.addEventListener('keypress', handleUserInteraction);

        // Poll notifications every 30 seconds
        const interval = setInterval(fetchNotifications, 30000);

        return () => {
            clearInterval(interval);
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('scroll', handleUserInteraction);
            document.removeEventListener('keypress', handleUserInteraction);
        };
    }, []);









    // Fetch the current attendance status on load
    useEffect(() => {
        const fetchAttendanceStatus = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${config.apiBASEURL}/attendance/fetch-attendance`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    params: { user_id: userId },
                });
                setCheckedIn(response.data.checkin_status);
            } catch (error) {
                console.error('Error fetching attendance status:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAttendanceStatus();
    }, [accessToken, userId]);

    // Check-in function
    const handleCheckIn = async () => {
        setLoading(true);
        try {
            const checkInTime = moment().format('HH:mm');
            const currentDate = moment().format('YYYY-MM-DD');

            await axios.post(`${config.apiBASEURL}/attendance/add-checkin`, {
                user_id: userId,
                start_time: checkInTime,
                date: currentDate
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}` // Send token in Authorization header
                }
            });

            setCheckedIn(true);
            // showMessage('success', 'Check-in successful!');
        } catch (error) {
            console.error('Error during check-in:', error);
            // const errorMessage = error.response?.data?.message || 'Error during check-in';
            // showMessage('error', errorMessage); // Display error message in toast
        } finally {
            await new Promise(resolve => setTimeout(resolve, 3000)); // 3-second delay in finally
            setLoading(false); // Always reset loading state after try/catch
        }
    };


    // Check-out function
    const handleCheckOut = async () => {
        setLoading(true);
        try {
            const checkOutTime = moment().format('HH:mm'); // Format time to HH:mm
            const currentDate = moment().format('YYYY-MM-DD'); // Format date to YYYY-MM-DD for backend compatibility

            await axios.put(`${config.apiBASEURL}/attendance/update-checkout/${userId}`, {
                date: currentDate,      // Include the date in the body in correct format
                end_time: checkOutTime  // Send the properly formatted time
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });

            setCheckedIn(false);
            // setElapsedTime('00:00'); // Reset the timer
            // showMessage('success', 'Check-out successful!');
        } catch (error) {
            console.error('Error during check-out:', error);
            // const errorMessage = error.response?.data?.message || 'Error during check-out';
            // showMessage('error', errorMessage); // Display error message
        }
        finally {
            setLoading(false); // Always reset loading state after try/catch
        }
    };

    const handleCheckInOut = () => {
        if (!checkedIn) {
            handleCheckIn();
        } else {
            setShowConfirmDialog(true); // Show confirmation dialog for checkout
        }
    };

    const confirmCheckOut = () => {
        handleCheckOut();
        setShowConfirmDialog(false);
    };


    const handlesantaClick = () => {
        navigate("/Graphe/dashboard/SecretSanta");
    };


    const getCheckInClass = (checkedIn) => {
        return checkedIn ? 'bg-success' : 'bg-secondary';
    };


    /*----------------dateandtime--------------*/
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(timer); // Cleanup interval on unmount
    }, []);

    // Format the date as dd/mm/yyyy
    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    /*--------EventModal-----------*/

    const [birthdayEvents, setBirthdayEvents] = useState([]);
    const [visibleBirthdays, setVisibleBirthdays] = useState({});
    const [anniversaryEvents, setAnniversaryEvents] = useState([]);
    const [visibleAnniversaryEvents, setVisibleAnniversaryEvents] = useState({});
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);


    useEffect(() => {
        if (!socket || !userId) return;

        // Request unread birthdays
        socket.emit("fetchUnreadBirthdays", { user_id: userId });

        // Listen for birthdays
        socket.on("unreadBirthdays", (events) => {
            const visibleState = {};
            events.forEach((ev) => {
                visibleState[ev.event_id] = true; // Auto open each dialog
            });
            setBirthdayEvents(events);
            setVisibleBirthdays(visibleState);
        });

        return () => {
            socket.off("unreadBirthdays");
        };
    }, [socket, userId]);


    useEffect(() => {
        if (!socket || !userId) return;

        // Request unread birthdays
        socket.emit("fetchUnreadAnniversaries", { user_id: userId });

        // Listen for birthdays
        socket.on("unreadAnniversaries", (events) => {
            const visibleState = {};
            events.forEach((ev) => {
                visibleState[ev.event_id] = true; // Auto open each dialog
            });
            setAnniversaryEvents(events);
            setVisibleAnniversaryEvents(visibleState);
        });

        return () => {
            socket.off("unreadAnniversaries");
        };
    }, [socket, userId]);



    const hideDialog = (eventId) => {
        setVisibleBirthdays((prev) => ({ ...prev, [eventId]: false }));
        socket.emit("markEventAsRead", eventId); // Mark as read
    };

    const hideAnniversaryDialog = (eventId) => {
        setVisibleAnniversaryEvents((prev) => ({ ...prev, [eventId]: false }));
        socket.emit("markEventAsRead", eventId); // Mark as read
    };

    const [prPopupNotifications, setPrPopupNotifications] = useState([]);
    const [showPrReviewPopup, setShowPrReviewPopup] = useState(false);

    useEffect(() => {
        if (!userId || !accessToken) return;

        let cancelled = false;
        // Wait briefly so profile/birthday dialogs settle, then show PR popup on top.
        const timer = setTimeout(async () => {
            try {
                const res = await axios.get(
                    `${config.apiBASEURL}/notificationRoutes/notifications/performance-review/unread/${userId}`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                const list = res.data?.notifications || [];
                if (!cancelled && list.length) {
                    setPrPopupNotifications(list);
                    setShowPrReviewPopup(true);
                }
            } catch (err) {
                console.error('Error loading performance review popup:', err);
            }
        }, 800);

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [userId, accessToken]);

    const prSelfReviewNotifs = prPopupNotifications.filter(
        (n) => n.notification_type === 'Performance Review Requested'
    );
    const prManagerRemarkNotifs = prPopupNotifications.filter(
        (n) => n.notification_type === 'Performance Review Remark Requested'
    );
    const prPopupIsManagerOnly =
        prManagerRemarkNotifs.length > 0 && prSelfReviewNotifs.length === 0;

    const dismissPrReviewPopup = async ({ openReviews = false } = {}) => {
        setShowPrReviewPopup(false);
        const toMark = [...prPopupNotifications];
        const firstManagerLink = prManagerRemarkNotifs[0]?.link_url;
        setPrPopupNotifications([]);
        try {
            await Promise.all(
                toMark.map((n) =>
                    axios.put(
                        `${config.apiBASEURL}/notificationRoutes/notifications/${n.notification_id}/mark-as-read`,
                        {},
                        { headers: { Authorization: `Bearer ${accessToken}` } }
                    )
                )
            );
        } catch (err) {
            console.error('Error marking performance review notifications as read:', err);
        }
        if (openReviews) {
            if (prPopupIsManagerOnly && firstManagerLink) {
                navigate(firstManagerLink);
            } else {
                navigate('/Graphe/dashboard/my_performance_reviews');
            }
        }
    };

    const [missingSections, setMissingSections] = useState([]);
    const [showDialog, setShowDialog] = useState(false);


    useEffect(() => {
        if (!userId) return;

        const checkProfile = async () => {
            try {
                setLoading(true);
                const res = await axios.get(
                    `${config.apiBASEURL}/user-profile/check-user-profile/${userId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                if (res.status === 200) {
                    // Profile incomplete → show dialog
                    setMissingSections(res.data.missingSections || []);
                    setShowDialog(true);
                } else if (res.status === 201) {
                    // Profile complete → no dialog
                    setShowDialog(false);
                }
            } catch (err) {
                console.error("Error checking profile:", err);
            } finally {
                setLoading(false);
            }
        };

        // Run immediately on mount
        checkProfile();

        // Run every 30 minutes (30 * 60 * 1000 = 1,800,000 ms)
        const interval = setInterval(checkProfile, 30 * 60 * 1000);

        // Cleanup on unmount
        return () => clearInterval(interval);
    }, [userId, accessToken]);





    // useEffect(() => {
    //     // Auto open both dialogs on page load
    //     setVisible1(true);
    //     setVisible2(true);
    //     setVisible3(true);
    //     setVisible4(true);
    // }, []);

    /*------------------------------------------------*/

    // Careers is granted by IAM permission, so it is shown for any role that holds it.
    const getCareersLinks = () => {
        const careersKeys = ['careers:view', 'careers:read_applications', 'careers:manage_candidates'];
        if (!isAuthenticated || !careersKeys.some(hasPermission)) return null;
        return (
            <div>
                <div onClick={() => setIsCareersOpen(!isCareersOpen)} style={{ cursor: 'pointer' }}>
                    <MenuItem className={isActive('/Graphe/dashboard/careers') ? 'active' : ''} icon={<FiBriefcase />}>
                        Careers
                        <span className="subIcon">
                            {isCareersOpen ? <TbMinus /> : <TbPlus />}
                        </span>
                    </MenuItem>
                </div>
                {isCareersOpen && (
                    <div className="submenu_padding">
                        {hasPermission('careers:view') && (
                            <NavLink to="/Graphe/dashboard/careers/jobs" activeClassName="active">
                                <MenuItem icon={<FiBriefcase />}>Job Postings</MenuItem>
                            </NavLink>
                        )}
                        {hasPermission('careers:read_applications') && (
                            <NavLink to="/Graphe/dashboard/careers/applications" activeClassName="active">
                                <MenuItem icon={<FiInbox />}>Applications</MenuItem>
                            </NavLink>
                        )}
                        {hasPermission('careers:manage_candidates') && (
                            <NavLink to="/Graphe/dashboard/careers/candidates" activeClassName="active">
                                <MenuItem icon={<FiUserCheck />}>Candidates</MenuItem>
                            </NavLink>
                        )}
                        {hasPermission('careers:manage_settings') && (
                            <NavLink to="/Graphe/dashboard/careers/categories" activeClassName="active">
                                <MenuItem icon={<FiTag />}>Job Categories</MenuItem>
                            </NavLink>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const getNavLinks = () => {
        // If user is not authenticated, only show Logout link
        if (!isAuthenticated) {
            return (
                <Menu iconShape="square">
                    <MenuItem icon={<FiLogOut />} onClick={handleLogout}>
                        Logout
                    </MenuItem>
                </Menu>
            );
        }



        // Show navigation links based on the user role
        switch (role) {

            case 'SuperAdmin':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/admin" activeClassName="active">
                            <MenuItem icon={<FiHome />}>
                                Dashboard
                            </MenuItem>
                        </NavLink>
                        {Array.isArray(permissions) && permissions.includes('iam:manage') && (
                            <NavLink to="/Graphe/dashboard/iam" activeClassName="active">
                                <MenuItem icon={<LuBookLock />}>
                                    Permissions
                                </MenuItem>
                            </NavLink>
                        )}

                        <div>
                            <div onClick={toggleSubmenu3} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/employee_list') ||
                                            isActive('/Graphe/dashboard/verify') ||
                                            isActive('/Graphe/dashboard/employ_promotion') ||
                                            isActive('/Graphe/dashboard/all_leaves') ||
                                            isActive('/Graphe/dashboard/overtime') ||
                                            isActive('/Graphe/dashboard/employee_report') ||
                                            isActive('/Graphe/dashboard/resignation_list') ||
                                            isActive('/Graphe/dashboard/admin_emp_expenses') ||
                                            isActive('/Graphe/dashboard/employee_salary_list') ||
                                            isActive('/Graphe/dashboard/org_hierarchy') ||
                                            isActive('/Graphe/dashboard/Holiday') // Match base path
                                            ? 'active' : ''}
                                    icon={<FiUsers />

                                    }>
                                    Employee
                                    <span className="subIcon">
                                        {isSubmenuOpen3 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen3 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                                        <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/update_designation" activeClassName="active">
                                        <MenuItem icon={<BiCog />}>Role Assign</MenuItem>
                                    </NavLink>

                                    <NavLink to="/Graphe/dashboard/all_leaves" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Employee Leaves</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/overtime" activeClassName="active">
                                        <MenuItem icon={<LuClock />}>Employee Overtime</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/employee_report" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Employee Report</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_templates" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Review Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_reviews" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Performance Reviews</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_emp_expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Employee Expenses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/resignation_list" activeClassName="active">
                                        <MenuItem icon={<GrDocumentUser />}>
                                            Resignation List
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/org_hierarchy" activeClassName="active">
                                        <MenuItem icon={<GiFamilyTree />}>
                                            Org Hierarchy
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Holiday" activeClassName="active">
                                        <MenuItem icon={<MdOutlineHolidayVillage />}>
                                            Holiday
                                        </MenuItem>
                                    </NavLink>


                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu8} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addbrand') ||
                                            isActive('/Graphe/dashboard/brandfile') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<SiBrandfolder />}
                                >
                                    Brand
                                    <span className="subIcon">
                                        {isSubmenuOpen8 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen8 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addbrand" activeClassName="active">
                                        <MenuItem icon={<PiListMagnifyingGlassBold />}>Add Brand</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brandfile" activeClassName="active">
                                        <MenuItem icon={<LiaSwatchbookSolid />}>Brand Book</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/post_upload" activeClassName="active">
                                        <MenuItem icon={<TbDatabaseShare />}>Post Data Sheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_projects') ||
                                            isActive('/Graphe/dashboard/all_projects') ||
                                            isActive('/Graphe/dashboard/boards_list') ||
                                            isActive('/Graphe/dashboard/user_gantt') ||
                                            isActive('/Graphe/dashboard/admin_gantt') ||
                                            isActive('/Graphe/dashboard/admin_user_gantt') ||
                                            isActive('/Graphe/dashboard/team_planner') ||
                                            isActive('/Graphe/dashboard/capacity_dashboard') ||
                                            isActive('/Graphe/dashboard/founder_calendar') ||
                                            isActive('/Graphe/dashboard/schedule_approvals') ||
                                            isActive('/Graphe/dashboard/mobile_gantt') ||
                                            isActive('/Graphe/dashboard/view_task') || // Match base path
                                            isActive('/Graphe/dashboard/project_track') ||
                                            isActive('/Graphe/dashboard/addtask') ||
                                            isActive('/Graphe/dashboard/brand_calendar') ||
                                            isActive('/Graphe/dashboard/tasklimitpage') ||
                                            isActive('/Graphe/dashboard/projects_details') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_projects" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Project</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>New Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Project Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>User Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/team_planner" activeClassName="active">
                                        <MenuItem icon={<FiUsers />}>Team Planner</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/founder_calendar" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Founder Calendar</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/capacity_dashboard" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Capacity Dashboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/schedule_approvals" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>Schedule Approvals</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brand_calendar" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Brand calander</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/tasklimitpage" activeClassName="active">
                                        <MenuItem icon={<PiListNumbersBold />}>Task Limit No.</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/project_track" activeClassName="active">
                                        <MenuItem icon={<PiNyTimesLogo />}>Task Log</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu9} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/daily_task') ||
                                            isActive('/Graphe/dashboard/dailytask_Admin')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiTrello />}
                                >
                                    Daily Tasksheet
                                    <span className="subIcon">
                                        {isSubmenuOpen9 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen9 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/dailytask_Admin" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>New Tasksheet</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/daily_task" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>Old Tasksheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu6} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addleaves') ||
                                            isActive('/Graphe/dashboard/add_leavebalance')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<RiCalendarEventLine />}
                                >
                                    Leave Type
                                    <span className="subIcon">
                                        {isSubmenuOpen6 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen6 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addleaves" activeClassName="active">
                                        <MenuItem icon={<RiCalendarEventLine />}>Add Leave Type</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/add_leavebalance" activeClassName="active">
                                        <MenuItem icon={<RiCalendarEventLine />}>Add Leave Balance</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu4} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_view_policy') ||
                                            isActive('/Graphe/dashboard/letter_template')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Company Documents
                                    <span className="subIcon">
                                        {isSubmenuOpen4 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen4 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_salary_list" activeClassName="active">
                                        <MenuItem icon={<TbReceiptRupee />}>Employee Payslip</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/add_view_policy" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Policy</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/letter_template" activeClassName="active">
                                        <MenuItem icon={<TfiPrinter />}>Letter Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/send_letter_list" activeClassName="active">
                                        <MenuItem icon={<RiMailSendLine />}>Send Letter</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/ticket_list" activeClassName="active">
                            <MenuItem icon={<IoTicketOutline />}>
                                View Ticket
                            </MenuItem>
                        </NavLink>


                        <div>
                            <div onClick={toggleSubmenu5} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/client_list') ||
                                            isActive('/Graphe/dashboard/Client_Submitted_form') ||
                                            isActive('/Graphe/dashboard/client_form_task_templates') ||
                                            isActive('/Graphe/dashboard/Form_select_onboarding') ||
                                            isActive('/Graphe/dashboard/onboarding_formlist') ||
                                            isActive('/Graphe/dashboard/Client_Project_Page') ||
                                            isActive('/Graphe/dashboard/client_link_list')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FaHandsHelping />}
                                >
                                    Our Clients
                                    <span className="subIcon">
                                        {isSubmenuOpen5 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen5 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/client_link_list" activeClassName="active">
                                        <MenuItem icon={<TbLinkPlus />}>Generate Register Links</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_list" activeClassName="active">
                                        <MenuItem icon={<FaUserTie />}>Client List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/onboarding_formlist" activeClassName="active">
                                        <MenuItem icon={<TbInputX />}>
                                            Create Form
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Form_select_onboarding" activeClassName="active">
                                        <MenuItem icon={<SiReaddotcv />}>Add Client Onboarding</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Submitted_form" activeClassName="active">
                                        <MenuItem icon={<PiCallBell />}>Client Form Responses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_form_task_templates" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Form Task Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Project_Page" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Client Ongoing Projects</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Adminleadlist" activeClassName="active">
                                        <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                                    </NavLink>
                                </div>
                            )}


                        </div>

                        <div>
                            <div onClick={toggleSubmenu7} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_service') ||
                                            isActive('/Graphe/dashboard/invoice_list') ||
                                            isActive('/Graphe/dashboard/payment') ||
                                            isActive('/Graphe/dashboard/template_invoice_list') ||
                                            isActive('/Graphe/dashboard/expenses') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<HiOutlineWallet />}
                                >
                                    Accounts
                                    <span className="subIcon">
                                        {isSubmenuOpen7 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen7 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_service" activeClassName="active">
                                        <MenuItem icon={<GrServices />}>Add Services</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/invoice_list" activeClassName="active">
                                        <MenuItem icon={<PiInvoice />}>Invoices</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/template_invoice_list" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Add Invoices Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/payment" activeClassName="active">
                                        <MenuItem icon={<RiSecurePaymentLine />}>Payments</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Expenses</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/SecretOrganizer" activeClassName="active">
                            <MenuItem icon={<GiSecretBook />}>
                                Secret Santa Organizer
                            </MenuItem>
                        </NavLink>
                    </>
                );

            case 'Admin':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/admin" activeClassName="active">
                            <MenuItem icon={<FiHome />}>
                                Dashboard
                            </MenuItem>
                        </NavLink>

                        <div>
                            <div onClick={toggleSubmenu3} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/employee_list') ||
                                            isActive('/Graphe/dashboard/verify') ||
                                            isActive('/Graphe/dashboard/employ_promotion') ||
                                            isActive('/Graphe/dashboard/all_leaves') ||
                                            isActive('/Graphe/dashboard/overtime') ||
                                            isActive('/Graphe/dashboard/employee_report') ||
                                            isActive('/Graphe/dashboard/resignation_list') ||
                                            isActive('/Graphe/dashboard/admin_emp_expenses') ||
                                            isActive('/Graphe/dashboard/employee_salary_list') ||
                                            isActive('/Graphe/dashboard/org_hierarchy') ||
                                            isActive('/Graphe/dashboard/Holiday') // Match base path
                                            ? 'active' : ''}
                                    icon={<FiUsers />

                                    }>
                                    Employee
                                    <span className="subIcon">
                                        {isSubmenuOpen3 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen3 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                                        <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/update_designation" activeClassName="active">
                                        <MenuItem icon={<BiCog />}>Role Assign</MenuItem>
                                    </NavLink>

                                    <NavLink to="/Graphe/dashboard/all_leaves" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Employee Leaves</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/overtime" activeClassName="active">
                                        <MenuItem icon={<LuClock />}>Employee Overtime</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/employee_report" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Employee Report</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_templates" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Review Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_reviews" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Performance Reviews</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_emp_expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Employee Expenses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/resignation_list" activeClassName="active">
                                        <MenuItem icon={<GrDocumentUser />}>
                                            Resignation List
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/org_hierarchy" activeClassName="active">
                                        <MenuItem icon={<GiFamilyTree />}>
                                            Org Hierarchy
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Holiday" activeClassName="active">
                                        <MenuItem icon={<MdOutlineHolidayVillage />}>
                                            Holiday
                                        </MenuItem>
                                    </NavLink>


                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu8} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addbrand') ||
                                            isActive('/Graphe/dashboard/brandfile') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<SiBrandfolder />}
                                >
                                    Brand
                                    <span className="subIcon">
                                        {isSubmenuOpen8 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen8 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addbrand" activeClassName="active">
                                        <MenuItem icon={<PiListMagnifyingGlassBold />}>Add Brand</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brandfile" activeClassName="active">
                                        <MenuItem icon={<LiaSwatchbookSolid />}>Brand Book</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/post_upload" activeClassName="active">
                                        <MenuItem icon={<TbDatabaseShare />}>Post Data Sheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_projects') ||
                                            isActive('/Graphe/dashboard/all_projects') ||
                                            isActive('/Graphe/dashboard/boards_list') ||
                                            isActive('/Graphe/dashboard/user_gantt') ||
                                            isActive('/Graphe/dashboard/admin_gantt') ||
                                            isActive('/Graphe/dashboard/admin_user_gantt') ||
                                            isActive('/Graphe/dashboard/team_planner') ||
                                            isActive('/Graphe/dashboard/capacity_dashboard') ||
                                            isActive('/Graphe/dashboard/founder_calendar') ||
                                            isActive('/Graphe/dashboard/schedule_approvals') ||
                                            isActive('/Graphe/dashboard/mobile_gantt') ||
                                            isActive('/Graphe/dashboard/view_task') || // Match base path
                                            isActive('/Graphe/dashboard/project_track') ||
                                            isActive('/Graphe/dashboard/addtask') ||
                                            isActive('/Graphe/dashboard/brand_calendar') ||
                                            isActive('/Graphe/dashboard/tasklimitpage') ||
                                            isActive('/Graphe/dashboard/projects_details') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_projects" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Project</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>New Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Project Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>User Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/team_planner" activeClassName="active">
                                        <MenuItem icon={<FiUsers />}>Team Planner</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/founder_calendar" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Founder Calendar</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/capacity_dashboard" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Capacity Dashboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/schedule_approvals" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>Schedule Approvals</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brand_calendar" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Brand calander</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/tasklimitpage" activeClassName="active">
                                        <MenuItem icon={<PiListNumbersBold />}>Task Limit No.</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/project_track" activeClassName="active">
                                        <MenuItem icon={<PiNyTimesLogo />}>Task Log</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu9} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/daily_task') ||
                                            isActive('/Graphe/dashboard/dailytask_Admin')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiTrello />}
                                >
                                    Daily Tasksheet
                                    <span className="subIcon">
                                        {isSubmenuOpen9 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen9 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/dailytask_Admin" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>New Tasksheet</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/daily_task" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>Old Tasksheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu6} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addleaves') ||
                                            isActive('/Graphe/dashboard/add_leavebalance')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<RiCalendarEventLine />}
                                >
                                    Leave Type
                                    <span className="subIcon">
                                        {isSubmenuOpen6 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen6 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addleaves" activeClassName="active">
                                        <MenuItem icon={<RiCalendarEventLine />}>Add Leave Type</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/add_leavebalance" activeClassName="active">
                                        <MenuItem icon={<RiCalendarEventLine />}>Add Leave Balance</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu4} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_view_policy') ||
                                            isActive('/Graphe/dashboard/letter_template')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Company Documents
                                    <span className="subIcon">
                                        {isSubmenuOpen4 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen4 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_salary_list" activeClassName="active">
                                        <MenuItem icon={<TbReceiptRupee />}>Employee Payslip</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/add_view_policy" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Policy</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/letter_template" activeClassName="active">
                                        <MenuItem icon={<TfiPrinter />}>Letter Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/send_letter_list" activeClassName="active">
                                        <MenuItem icon={<RiMailSendLine />}>Send Letter</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/ticket_list" activeClassName="active">
                            <MenuItem icon={<IoTicketOutline />}>
                                View Ticket
                            </MenuItem>
                        </NavLink>


                        <div>
                            <div onClick={toggleSubmenu5} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/client_list') ||
                                            isActive('/Graphe/dashboard/Client_Submitted_form') ||
                                            isActive('/Graphe/dashboard/client_form_task_templates') ||
                                            isActive('/Graphe/dashboard/Form_select_onboarding') ||
                                            isActive('/Graphe/dashboard/onboarding_formlist') ||
                                            isActive('/Graphe/dashboard/Client_Project_Page') ||
                                            isActive('/Graphe/dashboard/client_link_list')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FaHandsHelping />}
                                >
                                    Our Clients
                                    <span className="subIcon">
                                        {isSubmenuOpen5 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen5 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/client_link_list" activeClassName="active">
                                        <MenuItem icon={<TbLinkPlus />}>Generate Register Links</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_list" activeClassName="active">
                                        <MenuItem icon={<FaUserTie />}>Client List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/onboarding_formlist" activeClassName="active">
                                        <MenuItem icon={<TbInputX />}>
                                            Create Form
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Form_select_onboarding" activeClassName="active">
                                        <MenuItem icon={<SiReaddotcv />}>Add Client Onboarding</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Submitted_form" activeClassName="active">
                                        <MenuItem icon={<PiCallBell />}>Client Form Responses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_form_task_templates" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Form Task Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Project_Page" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Client Ongoing Projects</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Adminleadlist" activeClassName="active">
                                        <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                                    </NavLink>
                                </div>
                            )}


                        </div>

                        <div>
                            <div onClick={toggleSubmenu7} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_service') ||
                                            isActive('/Graphe/dashboard/invoice_list') ||
                                            isActive('/Graphe/dashboard/payment') ||
                                            isActive('/Graphe/dashboard/template_invoice_list') ||
                                            isActive('/Graphe/dashboard/expenses') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<HiOutlineWallet />}
                                >
                                    Accounts
                                    <span className="subIcon">
                                        {isSubmenuOpen7 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen7 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_service" activeClassName="active">
                                        <MenuItem icon={<GrServices />}>Add Services</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/invoice_list" activeClassName="active">
                                        <MenuItem icon={<PiInvoice />}>Invoices</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/template_invoice_list" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Add Invoices Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/payment" activeClassName="active">
                                        <MenuItem icon={<RiSecurePaymentLine />}>Payments</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Expenses</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/SecretOrganizer" activeClassName="active">
                            <MenuItem icon={<GiSecretBook />}>
                                Secret Santa Organizer
                            </MenuItem>
                        </NavLink>
                    </>
                );

            case 'Founder':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/admin" activeClassName="active">
                            <MenuItem icon={<FiHome />}>
                                Dashboard
                            </MenuItem>
                        </NavLink>

                        <div>
                            <div onClick={toggleSubmenu3} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/employee_list') ||
                                            isActive('/Graphe/dashboard/verify') ||
                                            isActive('/Graphe/dashboard/employ_promotion') ||
                                            isActive('/Graphe/dashboard/all_leaves') ||
                                            isActive('/Graphe/dashboard/overtime') ||
                                            isActive('/Graphe/dashboard/employee_report') ||
                                            isActive('/Graphe/dashboard/resignation_list') ||
                                            isActive('/Graphe/dashboard/admin_emp_expenses') ||
                                            isActive('/Graphe/dashboard/employee_salary_list') ||
                                            isActive('/Graphe/dashboard/org_hierarchy') ||
                                            isActive('/Graphe/dashboard/Holiday') // Match base path
                                            ? 'active' : ''}
                                    icon={<FiUsers />

                                    }>
                                    Employee
                                    <span className="subIcon">
                                        {isSubmenuOpen3 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen3 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                                        <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/update_designation" activeClassName="active">
                                        <MenuItem icon={<BiCog />}>Role Assign</MenuItem>
                                    </NavLink>

                                    <NavLink to="/Graphe/dashboard/all_leaves" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Employee Leaves</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/overtime" activeClassName="active">
                                        <MenuItem icon={<LuClock />}>Employee Overtime</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/employee_report" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Employee Report</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_templates" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Review Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_reviews" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Performance Reviews</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_emp_expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Employee Expenses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/resignation_list" activeClassName="active">
                                        <MenuItem icon={<GrDocumentUser />}>
                                            Resignation List
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/org_hierarchy" activeClassName="active">
                                        <MenuItem icon={<GiFamilyTree />}>
                                            Org Hierarchy
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Holiday" activeClassName="active">
                                        <MenuItem icon={<MdOutlineHolidayVillage />}>
                                            Holiday
                                        </MenuItem>
                                    </NavLink>


                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu8} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addbrand') ||
                                            isActive('/Graphe/dashboard/brandfile') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<SiBrandfolder />}
                                >
                                    Brand
                                    <span className="subIcon">
                                        {isSubmenuOpen8 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen8 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addbrand" activeClassName="active">
                                        <MenuItem icon={<PiListMagnifyingGlassBold />}>Add Brand</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brandfile" activeClassName="active">
                                        <MenuItem icon={<LiaSwatchbookSolid />}>Brand Book</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/post_upload" activeClassName="active">
                                        <MenuItem icon={<TbDatabaseShare />}>Post Data Sheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_projects') ||
                                            isActive('/Graphe/dashboard/all_projects') ||
                                            isActive('/Graphe/dashboard/boards_list') ||
                                            isActive('/Graphe/dashboard/user_gantt') ||
                                            isActive('/Graphe/dashboard/admin_gantt') ||
                                            isActive('/Graphe/dashboard/admin_user_gantt') ||
                                            isActive('/Graphe/dashboard/team_planner') ||
                                            isActive('/Graphe/dashboard/capacity_dashboard') ||
                                            isActive('/Graphe/dashboard/founder_calendar') ||
                                            isActive('/Graphe/dashboard/schedule_approvals') ||
                                            isActive('/Graphe/dashboard/mobile_gantt') ||
                                            isActive('/Graphe/dashboard/view_task') || // Match base path
                                            isActive('/Graphe/dashboard/project_track') ||
                                            isActive('/Graphe/dashboard/addtask') ||
                                            isActive('/Graphe/dashboard/brand_calendar') ||
                                            isActive('/Graphe/dashboard/tasklimitpage') ||
                                            isActive('/Graphe/dashboard/projects_details') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_projects" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Project</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>New Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Project Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/admin_user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>User Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/team_planner" activeClassName="active">
                                        <MenuItem icon={<FiUsers />}>Team Planner</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/founder_calendar" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Founder Calendar</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/capacity_dashboard" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Capacity Dashboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/schedule_approvals" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>Schedule Approvals</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brand_calendar" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Brand calander</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/tasklimitpage" activeClassName="active">
                                        <MenuItem icon={<PiListNumbersBold />}>Task Limit No.</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/project_track" activeClassName="active">
                                        <MenuItem icon={<PiNyTimesLogo />}>Task Log</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu9} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/daily_task') ||
                                            isActive('/Graphe/dashboard/dailytask_Admin')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiTrello />}
                                >
                                    Daily Tasksheet
                                    <span className="subIcon">
                                        {isSubmenuOpen9 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen9 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/dailytask_Admin" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>New Tasksheet</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/daily_task" activeClassName="active">
                                        <MenuItem icon={<FiTrello />}>Old Tasksheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu6} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addleaves') ||
                                            isActive('/Graphe/dashboard/add_leavebalance')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<RiCalendarEventLine />}
                                >
                                    Leave Type
                                    <span className="subIcon">
                                        {isSubmenuOpen6 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen6 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addleaves" activeClassName="active">
                                        <MenuItem icon={<RiCalendarEventLine />}>Add Leave Type</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/add_leavebalance" activeClassName="active">
                                        <MenuItem icon={<RiCalendarEventLine />}>Add Leave Balance</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu4} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_view_policy') ||
                                            isActive('/Graphe/dashboard/letter_template')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Company Documents
                                    <span className="subIcon">
                                        {isSubmenuOpen4 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen4 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_salary_list" activeClassName="active">
                                        <MenuItem icon={<TbReceiptRupee />}>Employee Payslip</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/add_view_policy" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Policy</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/letter_template" activeClassName="active">
                                        <MenuItem icon={<TfiPrinter />}>Letter Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/send_letter_list" activeClassName="active">
                                        <MenuItem icon={<RiMailSendLine />}>Send Letter</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/ticket_list" activeClassName="active">
                            <MenuItem icon={<IoTicketOutline />}>
                                View Ticket
                            </MenuItem>
                        </NavLink>


                        <div>
                            <div onClick={toggleSubmenu5} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/client_list') ||
                                            isActive('/Graphe/dashboard/Client_Submitted_form') ||
                                            isActive('/Graphe/dashboard/client_form_task_templates') ||
                                            isActive('/Graphe/dashboard/Form_select_onboarding') ||
                                            isActive('/Graphe/dashboard/onboarding_formlist') ||
                                            isActive('/Graphe/dashboard/Client_Project_Page') ||
                                            isActive('/Graphe/dashboard/client_link_list')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FaHandsHelping />}
                                >
                                    Our Clients
                                    <span className="subIcon">
                                        {isSubmenuOpen5 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen5 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/client_link_list" activeClassName="active">
                                        <MenuItem icon={<TbLinkPlus />}>Generate Register Links</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_list" activeClassName="active">
                                        <MenuItem icon={<FaUserTie />}>Client List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/onboarding_formlist" activeClassName="active">
                                        <MenuItem icon={<TbInputX />}>
                                            Create Form
                                        </MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Form_select_onboarding" activeClassName="active">
                                        <MenuItem icon={<SiReaddotcv />}>Add Client Onboarding</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Submitted_form" activeClassName="active">
                                        <MenuItem icon={<PiCallBell />}>Client Form Responses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_form_task_templates" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Form Task Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Project_Page" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Client Ongoing Projects</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Adminleadlist" activeClassName="active">
                                        <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                                    </NavLink>
                                </div>
                            )}


                        </div>

                        <div>
                            <div onClick={toggleSubmenu7} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_service') ||
                                            isActive('/Graphe/dashboard/invoice_list') ||
                                            isActive('/Graphe/dashboard/payment') ||
                                            isActive('/Graphe/dashboard/template_invoice_list') ||
                                            isActive('/Graphe/dashboard/expenses') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<HiOutlineWallet />}
                                >
                                    Accounts
                                    <span className="subIcon">
                                        {isSubmenuOpen7 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen7 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_service" activeClassName="active">
                                        <MenuItem icon={<GrServices />}>Add Services</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/invoice_list" activeClassName="active">
                                        <MenuItem icon={<PiInvoice />}>Invoices</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/template_invoice_list" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Add Invoices Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/payment" activeClassName="active">
                                        <MenuItem icon={<RiSecurePaymentLine />}>Payments</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Expenses</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/SecretOrganizer" activeClassName="active">
                            <MenuItem icon={<GiSecretBook />}>
                                Secret Santa Organizer
                            </MenuItem>
                        </NavLink>
                    </>
                );

            case 'Task_manager':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/employee" activeClassName="active">
                            <MenuItem icon={<FiHome />}>Dashboard</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/brand_calendar" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Brand calander</MenuItem>
                        </NavLink>
                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/all_projects') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">

                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    {/*<NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Comming Soon</MenuItem>
                                    </NavLink>*/}
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/team_planner" activeClassName="active">
                                        <MenuItem icon={<FiUsers />}>Team Planner</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/mobile_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Mobile Timeline</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <div>
                            <div onClick={toggleSubmenu8} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addbrand') ||
                                            isActive('/Graphe/dashboard/brandfile') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<SiBrandfolder />}
                                >
                                    Brand
                                    <span className="subIcon">
                                        {isSubmenuOpen8 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen8 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addbrand" activeClassName="active">
                                        <MenuItem icon={<PiListMagnifyingGlassBold />}>Add Brand</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brandfile" activeClassName="active">
                                        <MenuItem icon={<LiaSwatchbookSolid />}>Brand Book</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/post_upload" activeClassName="active">
                                        <MenuItem icon={<TbDatabaseShare />}>Post Data Sheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                            <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/single_employee_report" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>Monthly Report</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/my_performance_reviews" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>My Performance Reviews</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/leave_apply" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Leaves</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/overtime" activeClassName="active">
                            <MenuItem icon={<LuClock />}>Employee Overtime</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee-overtime" activeClassName="active">
                            <MenuItem icon={<LuClock />}>Overtime </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/dailytask_employee" activeClassName="active">
                            <MenuItem icon={<FiTrello />}>Daily Tasksheet </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_letter_list" activeClassName="active">
                            <MenuItem icon={<RiDownloadCloud2Fill />}>Download Documents </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/view_policy" activeClassName="active">
                            <MenuItem icon={<MdPolicy />}>Company Policies </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_resignation_list" activeClassName="active">
                            <MenuItem icon={<GrDocumentUser />}>
                                Resignation
                            </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Client_Lead" activeClassName="active">
                            <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Employee_Deduction_expenses" activeClassName="active">
                            <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Add Expenses</MenuItem>
                        </NavLink>
                    </>
                );

            case 'Social_Media_Manager':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/employee" activeClassName="active">
                            <MenuItem icon={<FiHome />}>Dashboard</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/brand_calendar" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Brand calander</MenuItem>
                        </NavLink>
                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/all_projects') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">

                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    {/*<NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Comming Soon</MenuItem>
                                    </NavLink>*/}
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/mobile_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Mobile Timeline</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <div>
                            <div onClick={toggleSubmenu8} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addbrand') ||
                                            isActive('/Graphe/dashboard/brandfile') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<SiBrandfolder />}
                                >
                                    Brand
                                    <span className="subIcon">
                                        {isSubmenuOpen8 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen8 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addbrand" activeClassName="active">
                                        <MenuItem icon={<PiListMagnifyingGlassBold />}>Add Brand</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brandfile" activeClassName="active">
                                        <MenuItem icon={<LiaSwatchbookSolid />}>Brand Book</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/post_upload" activeClassName="active">
                                        <MenuItem icon={<TbDatabaseShare />}>Post Data Sheet</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                            <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/single_employee_report" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>Monthly Report</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/my_performance_reviews" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>My Performance Reviews</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/leave_apply" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Leaves</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee-overtime" activeClassName="active">
                            <MenuItem icon={<LuClock />}>Overtime </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/dailytask_employee" activeClassName="active">
                            <MenuItem icon={<FiTrello />}>Daily Tasksheet </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_letter_list" activeClassName="active">
                            <MenuItem icon={<RiDownloadCloud2Fill />}>Download Documents </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/view_policy" activeClassName="active">
                            <MenuItem icon={<MdPolicy />}>Company Policies </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_resignation_list" activeClassName="active">
                            <MenuItem icon={<GrDocumentUser />}>
                                Resignation
                            </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Client_Lead" activeClassName="active">
                            <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Employee_Deduction_expenses" activeClassName="active">
                            <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Add Expenses</MenuItem>
                        </NavLink>
                        {/* <NavLink to="/dashboard/brand_calendar" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Brand calander</MenuItem>
                        </NavLink> */}
                    </>
                );

            case 'Employee':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/employee" activeClassName="active">
                            <MenuItem icon={<FiHome />}>Dashboard</MenuItem>
                        </NavLink>
                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/all_projects') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">

                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    {/*<NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Comming Soon</MenuItem>
                                    </NavLink>*/}
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/mobile_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Mobile Timeline</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                            <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/single_employee_report" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>Monthly Report</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/my_performance_reviews" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>My Performance Reviews</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/leave_apply" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Leaves</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee-overtime" activeClassName="active">
                            <MenuItem icon={<LuClock />}>Overtime </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/dailytask_employee" activeClassName="active">
                            <MenuItem icon={<FiTrello />}>Daily Tasksheet </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_resignation_list" activeClassName="active">
                            <MenuItem icon={<GrDocumentUser />}>
                                Resignation
                            </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Client_Lead" activeClassName="active">
                            <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Employee_Deduction_expenses" activeClassName="active">
                            <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Add Expenses</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_letter_list" activeClassName="active">
                            <MenuItem icon={<RiDownloadCloud2Fill />}>Download Documents </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/view_policy" activeClassName="active">
                            <MenuItem icon={<MdPolicy />}>Company Policies </MenuItem>
                        </NavLink>
                    </>
                );
            case 'Department_Head':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/employee" activeClassName="active">
                            <MenuItem icon={<FiHome />}>Dashboard</MenuItem>
                        </NavLink>
                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/all_projects') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">

                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    {/*<NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Comming Soon</MenuItem>
                                    </NavLink>*/}
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/team_planner" activeClassName="active">
                                        <MenuItem icon={<FiUsers />}>Team Planner</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/mobile_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Mobile Timeline</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                        <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                            <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/single_employee_report" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>Monthly Report</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/my_performance_reviews" activeClassName="active">
                            <MenuItem icon={<TbReportSearch />}>My Performance Reviews</MenuItem>
                        </NavLink>

                        <NavLink to="/Graphe/dashboard/leave_apply" activeClassName="active">
                            <MenuItem icon={<FiCalendar />}>Leaves</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee-overtime" activeClassName="active">
                            <MenuItem icon={<LuClock />}>Overtime </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/dailytask_employee" activeClassName="active">
                            <MenuItem icon={<FiTrello />}>Daily Tasksheet </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_resignation_list" activeClassName="active">
                            <MenuItem icon={<GrDocumentUser />}>
                                Resignation
                            </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Client_Lead" activeClassName="active">
                            <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/Employee_Deduction_expenses" activeClassName="active">
                            <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Add Expenses</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_letter_list" activeClassName="active">
                            <MenuItem icon={<RiDownloadCloud2Fill />}>Download Documents </MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/view_policy" activeClassName="active">
                            <MenuItem icon={<MdPolicy />}>Company Policies </MenuItem>
                        </NavLink>
                    </>
                );

            case 'HumanResource':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/hr" activeClassName="active">
                            <MenuItem icon={<FiHome />}>
                                Dashboard
                            </MenuItem>
                        </NavLink>

                        <div>
                            <div onClick={toggleSubmenu3} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/employee_list') ||
                                            isActive('/Graphe/dashboard/verify') ||
                                            isActive('/Graphe/dashboard/employ_promotion') ||
                                            isActive('/Graphe/dashboard/all_leaves') ||
                                            isActive('/Graphe/dashboard/overtime') ||
                                            isActive('/Graphe/dashboard/employee_report') ||
                                            isActive('/Graphe/dashboard/Employee_Deduction_expenses') ||
                                            isActive('/Graphe/dashboard/resignation_list')
                                            ? 'active' : ''}
                                    icon={<FiUsers />

                                    }>
                                    Employee
                                    <span className="subIcon">
                                        {isSubmenuOpen3 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen3 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                                        <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/update_designation" activeClassName="active">
                                        <MenuItem icon={<BiCog />}>Update Designation</MenuItem>
                                    </NavLink>

                                    <NavLink to="/Graphe/dashboard/all_leaves" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Employee Leaves</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/overtime" activeClassName="active">
                                        <MenuItem icon={<LuClock />}>Employee Overtime</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/employee_report" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Employee Report</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_templates" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Review Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/performance_reviews" activeClassName="active">
                                        <MenuItem icon={<TbReportSearch />}>Performance Reviews</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Employee_Deduction_expenses" activeClassName="active">
                                        <MenuItem icon={<LiaFileInvoiceDollarSolid />}>Add Expenses</MenuItem>
                                    </NavLink>
                                    {/* <NavLink to="/Graphe/dashboard/resignation_list" activeClassName="active">
                                        <MenuItem icon={<BiUserMinus />}>Resignation</MenuItem>
                                    </NavLink> */}
                                    {/* <NavLink to="/Graphe/dashboard/Client_Lead" activeClassName="active">
                                        <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                                    </NavLink> */}
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu8} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/addbrand') ||
                                            isActive('/Graphe/dashboard/brandfile') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<SiBrandfolder />}
                                >
                                    Brand
                                    <span className="subIcon">
                                        {isSubmenuOpen8 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen8 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/addbrand" activeClassName="active">
                                        <MenuItem icon={<PiListMagnifyingGlassBold />}>Add Brand</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/brandfile" activeClassName="active">
                                        <MenuItem icon={<LiaSwatchbookSolid />}>Brand Book</MenuItem>
                                    </NavLink>
                                    {/* <NavLink to="/Graphe/dashboard/post_upload" activeClassName="active">
                                        <MenuItem icon={<TbDatabaseShare />}>Post Data Sheet</MenuItem>
                                    </NavLink> */}
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu2} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_projects') ||
                                            isActive('/Graphe/dashboard/all_projects') ||
                                            isActive('/Graphe/dashboard/boards_list') ||
                                            isActive('/Graphe/dashboard/user_gantt') ||
                                            isActive('/Graphe/dashboard/admin_gantt') ||
                                            isActive('/Graphe/dashboard/admin_user_gantt') ||
                                            isActive('/Graphe/dashboard/team_planner') ||
                                            isActive('/Graphe/dashboard/capacity_dashboard') ||
                                            isActive('/Graphe/dashboard/founder_calendar') ||
                                            isActive('/Graphe/dashboard/schedule_approvals') ||
                                            isActive('/Graphe/dashboard/mobile_gantt') ||
                                            isActive('/Graphe/dashboard/view_task') ||
                                            isActive('/Graphe/dashboard/addtask') ||
                                            isActive('/Graphe/dashboard/projects_details') // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Projects
                                    <span className="subIcon">
                                        {isSubmenuOpen2 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen2 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_projects" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Project</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/all_projects" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Project List</MenuItem>
                                    </NavLink>
                                    {/*<NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbListNumbers />}>Comming Soon</MenuItem>
                                    </NavLink>*/}
                                    <NavLink to="/Graphe/dashboard/boards_list" activeClassName="active">
                                        <MenuItem icon={<TbLayoutBoardSplit />}>Taskboard</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/user_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>My Timeline</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/mobile_gantt" activeClassName="active">
                                        <MenuItem icon={<FiCalendar />}>Mobile Timeline</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        <NavLink to="/Graphe/dashboard/dailytask_Admin" activeClassName="active">
                            <MenuItem icon={<FiTrello />}>
                                Daily Tasksheet
                            </MenuItem>
                        </NavLink>
                        {/* <div>
                            <div onClick={toggleSubmenu4} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_view_policy') ||
                                            isActive('/Graphe/dashboard/letter_template')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Company Documents
                                    <span className="subIcon">
                                        {isSubmenuOpen4 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen4 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/add_view_policy" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Policy</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/letter_template" activeClassName="active">
                                        <MenuItem icon={<TfiPrinter />}>Letter Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/send_letter_list" activeClassName="active">
                                        <MenuItem icon={<RiMailSendLine />}>Send Letter</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div> */}
                         <div>
                            <div onClick={toggleSubmenu5} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/client_list') ||
                                            isActive('/Graphe/dashboard/Client_Submitted_form') ||
                                            isActive('/Graphe/dashboard/client_form_task_templates') ||
                                            isActive('/Graphe/dashboard/onboarding_formlist') ||
                                            isActive('/Graphe/dashboard/Form_select_onboarding') ||
                                            isActive('/Graphe/dashboard/client_link_list')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FaHandsHelping />}
                                >
                                    Our Clients
                                    <span className="subIcon">
                                        {isSubmenuOpen5 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen5 && (
                                <div className="submenu_padding">
                                    <NavLink to="/Graphe/dashboard/client_link_list" activeClassName="active">
                                        <MenuItem icon={<TbLinkPlus />}>Generate Register Links</MenuItem>
                                    </NavLink>
                                    {/* <NavLink to="/Graphe/dashboard/onboarding_formlist" activeClassName="active">
                                        <MenuItem icon={<TbInputX />}>
                                            Create Form
                                        </MenuItem>
                                    </NavLink> */}
                                    <NavLink to="/Graphe/dashboard/client_list" activeClassName="active">
                                        <MenuItem icon={<FaUserTie />}>Client List</MenuItem>
                                    </NavLink>
                                    {/* <NavLink to="/Graphe/dashboard/Form_select_onboarding" activeClassName="active">
                                        <MenuItem icon={<SiReaddotcv />}>Add Client Onboarding</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Client_Submitted_form" activeClassName="active">
                                        <MenuItem icon={<PiCallBell />}>Client Form Responses</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/client_form_task_templates" activeClassName="active">
                                        <MenuItem icon={<TbTemplate />}>Form Task Templates</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/Adminleadlist" activeClassName="active">
                                        <MenuItem icon={<VscReferences />}>Client Referrals</MenuItem>
                                    </NavLink> */}
                                </div>
                            )}
                        </div>

                        <div>
                            <div onClick={toggleSubmenu4} style={{ cursor: 'pointer' }}>
                                <MenuItem
                                    className={
                                        isActive('/Graphe/dashboard/add_view_policy') ||
                                            isActive('/Graphe/dashboard/letter_template')  // Match base path
                                            ? 'active'
                                            : ''
                                    }
                                    icon={<FiFolder />}
                                >
                                    Company Documents
                                    <span className="subIcon">
                                        {isSubmenuOpen4 ? <TbMinus /> : <TbPlus />}
                                    </span>
                                </MenuItem>
                            </div>
                            {isSubmenuOpen4 && (
                                <div className="submenu_padding">
                                    {/* <NavLink to="/Graphe/dashboard/employee_salary_list" activeClassName="active">
                                        <MenuItem icon={<TbReceiptRupee />}>Employee Payslip</MenuItem>
                                    </NavLink> */}
                                    <NavLink to="/Graphe/dashboard/add_view_policy" activeClassName="active">
                                        <MenuItem icon={<RiFolderAddLine />}>Add Policy</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/letter_template" activeClassName="active">
                                        <MenuItem icon={<TfiPrinter />}>Letter Template</MenuItem>
                                    </NavLink>
                                    <NavLink to="/Graphe/dashboard/send_letter_list" activeClassName="active">
                                        <MenuItem icon={<RiMailSendLine />}>Send Letter</MenuItem>
                                    </NavLink>
                                </div>
                            )}
                        </div>

                    </>
                );

            case 'Unverified':
                return (
                    <>

                    </>
                );

            case 'Ex_employee':
                return (
                    <>
                        <NavLink to="/Graphe/dashboard/exemployee" activeClassName="active">
                            <MenuItem icon={<FiHome />}>Dashboard</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_list" activeClassName="active">
                            <MenuItem icon={<HiOutlineUsers />}>Employee List</MenuItem>
                        </NavLink>
                        <NavLink to="/Graphe/dashboard/employee_letter_list" activeClassName="active">
                            <MenuItem icon={<RiDownloadCloud2Fill />}>Download Documents </MenuItem>
                        </NavLink>
                    </>
                );



            default:
                return null;
        }
    };


    return (
        <div id="header">
            {eventStatus === "active" && (
                <div className='sec_sanbutton2' onClick={handlesantaClick} style={{ cursor: "pointer" }}>
                    <img src={"https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/santabutton.png"} alt="secret santa" className='w-100' />
                </div>
            )}

            <div className='topheader'>
                <div className='position-relative'>
                    <div className="logotext">
                        {menuCollapse ? (
                            <p><img src={require("../../assets/images/logogf.png")} alt="Logo" style={{ width: '30px', height: '30px' }} /></p>
                        ) : (
                            <p><img src={require("../../assets/images/logogf.png")} alt="Logo" style={{ width: '30px', height: '30px', marginRight: '10px' }} /><span> BlackBox</span></p>
                        )}
                    </div>
                    <div className="closemenu" onClick={menuIconClick}>
                        {menuCollapse ? <IoToggleOutline /> : <IoToggleSharp />}
                    </div>
                </div>
                <div>
                    <ul>
                        {isAuthenticated && role !== 'Unverified' && role !== 'Ex_employee' && (
                            <li className='iconsize position-relative' style={{ display: 'flex', alignItems: 'center' }}>
                                <ConfirmDialog
                                    visible={showConfirmDialog}
                                    onHide={() => setShowConfirmDialog(false)}
                                    message="Are you sure you want to check out?"
                                    header="Confirm Check Out"
                                    icon="pi pi-exclamation-triangle"
                                    accept={confirmCheckOut}
                                    reject={() => setShowConfirmDialog(false)}
                                />
                                <Button
                                    label={loading
                                        ? (checkedIn ? 'Checking In... ' : 'Checking Out...')
                                        : (checkedIn ? 'Check Out' : 'Check In')}
                                    icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-clock'}
                                    severity={checkedIn ? 'danger' : 'success'}
                                    onClick={handleCheckInOut}
                                    disabled={loading}
                                    className={`py-2 border-0 `}
                                />
                            </li>
                        )}

                        <li className='iconsize position-relative'>
                            <h6 className='text-secondary me-3 pt-2'>
                                {time.toLocaleTimeString()} &nbsp; | &nbsp;
                                {` Office - ${role}`} &nbsp; | &nbsp;

                            </h6>
                        </li>
                        {isAuthenticated && role !== 'Unverified' && role !== 'Ex_employee' && (
                            <li className='iconsize position-relative'>
                                <Link to="/Graphe/dashboard/calendar">
                                    <i className='pi pi-calendar-plus me-3 text-danger' style={{ fontSize: '18px' }} title='Add & View Holiday'></i>
                                </Link>
                                <Link to="/Graphe/dashboard/all_notifications">
                                    {hasUnread ? (
                                        <>
                                            <VscBellDot className='text-danger' />
                                            <div className="ripple-loader red">
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </>
                                    ) : (
                                        <LuBell className='text-secondary' />
                                    )}
                                </Link>
                            </li>
                        )}

                        <li>
                            <DropdownButton
                                className='userdrop'
                                id="dropdown-basic-button"
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={profileImageUrl ? profileImageUrl : require("../../assets/images/no_user.png")}
                                            alt="Logo"
                                            style={{ width: '32px', height: '32px', marginRight: '10px' }}
                                        />
                                        <small className={getCheckInClass(isAuthenticated)}></small>
                                        {username}
                                    </div>
                                }
                            >
                                <Dropdown.Item tag={Link} onClick={viewprofile}>
                                    <IoPersonOutline /> My Profile
                                </Dropdown.Item>
                                <Dropdown.Item tag={Link} onClick={viewticket}>
                                    <IoTicketOutline /> Raise Ticket
                                </Dropdown.Item>
                                <Dropdown.Item tag={Link} onClick={handleLogout}>
                                    <FiLogOut /> Logout
                                </Dropdown.Item>
                            </DropdownButton>
                        </li>
                    </ul>
                </div>
            </div>
            <Sidebar collapsed={menuCollapse} className="sidebar">
                {/* <div className="logotext">
                    {menuCollapse ? (
                        <p><img src={require("../../assets/images/logogf.png")} alt="Logo" style={{ width: '30px', height: '30px' }} /></p>
                    ) : (
                        <p><img src={require("../../assets/images/logogf.png")} alt="Logo" style={{ width: '30px', height: '30px', marginRight: '10px' }} /> BlackBox</p>
                    )}
                </div>
                <div className="closemenu" onClick={menuIconClick}>
                    {menuCollapse ? <IoToggleOutline /> : <IoToggleSharp />}
                </div> */}
                <Menu iconShape="square">
                    {getNavLinks()}
                    {getCareersLinks()}
                </Menu>
            </Sidebar>

            {/* <NotificationToast ref={notificationToastRef} /> */}

            <div className='empEvnDilog'>
                {/* Birthday Dialog */}
                {birthdayEvents.map((event) => (
                    <Dialog
                        key={event.event_id}
                        visible={visibleBirthdays[event.event_id]}
                        style={{ width: '350px', height: '491px' }}
                        onHide={() => hideDialog(event.event_id)}
                        className="empEvnDilog"
                    >
                        <img
                            src="https://ik.imagekit.io/blackboxv2/Graphe-logo/frame.png?updatedAt=1746014898851"
                            className="evd_bg"
                            alt="logo"
                        />
                        <div className="birthEv">
                            <img
                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Birthday.png?updatedAt=1746009480308"
                                alt="logo"
                            />
                        </div>
                        <img
                            src={event.sourceUser?.profileImage?.image_url || 'https://ik.imagekit.io/blackboxv2/profile-images/default.png'}
                            className="ev_empimg"
                            alt="Employee"
                        />
                        <div className="empNameEv">
                            <h6>{`${event.sourceUser?.first_name} ${event.sourceUser?.last_name}`}</h6>
                        </div>
                    </Dialog>
                ))}


                {/* Work Anniversary Dialog */}
                {anniversaryEvents.map((event) => (
                    <Dialog
                        key={event.event_id}
                        visible={visibleAnniversaryEvents[event.event_id]}
                        style={{ width: '350px', height: '491px' }}
                        onHide={() => hideAnniversaryDialog(event.event_id)}
                        className='empEvnDilog'
                    >
                        <img
                            src="https://ik.imagekit.io/blackboxv2/Graphe-logo/frame.png?updatedAt=1746014898851"
                            className='evd_bg'
                            alt="frame"
                        />
                        <div className='birthEv'>
                            <img
                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Work%20Anniversary.png?updatedAt=1746009480368"
                                alt="work anniversary"
                                className='workEV'
                            />
                        </div>
                        <img
                            src={event.sourceUser?.profileImage?.image_url || 'https://ik.imagekit.io/blackboxv2/profile-images/default.png'}
                            className='ev_empimg'
                            alt="employee"
                        />
                        <div className='empNameEv'>
                            <h6>{event.sourceUser?.first_name} {event.sourceUser?.last_name}</h6>
                        </div>
                    </Dialog>
                ))}


                {/* Work Newjoin Dialog */}
                <Dialog visible={visible3} style={{ width: '350px', height: '491px' }} onHide={() => setVisible3(false)} className='empEvnDilog'>
                    <img src="https://ik.imagekit.io/blackboxv2/Graphe-logo/frame.png?updatedAt=1746014898851" className='evd_bg' alt="logo" />
                    <div className='birthEv'>
                        <img src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Newjoin.png?updatedAt=1746009480391" alt="logo" className='workEV' />
                    </div>
                    <img src='https://ik.imagekit.io/blackboxv2/profile-images/3d-rendering-cartoon-like-boy-removebg-preview__t730Swaaf.png?updatedAt=1743419768655' className='ev_empimg' />
                    <div className='empNameEv'>
                        <h6>Employee Name</h6>
                    </div>
                </Dialog>

                <Dialog
                    header="Profile Incomplete"
                    visible={showDialog}
                    onHide={() => setShowDialog(false)}
                    style={{ width: "340px" }}
                    footer={
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                label="Go to Profile"
                                icon="pi pi-user"
                                severity="warning"
                                className='py-2 border-0 '
                                onClick={viewprofile}
                            />
                            <Button
                                label="OK"
                                icon="pi pi-check"
                                severity="secondary"
                                className='py-2 border-0 '
                                onClick={() => setShowDialog(false)}
                                autoFocus
                            />

                        </div>
                    }
                >
                    {loading ? (
                        <p>Checking profile...</p>
                    ) : missingSections.length > 0 ? (
                        <ul className="profile-incomplete-list">
                            {missingSections.map((section, idx) => (
                                <li key={idx}>{section}</li>
                            ))}
                        </ul>
                    ) : (
                        <p>Profile looks complete.</p>
                    )}
                </Dialog>

                <Dialog
                    header={
                        prPopupIsManagerOnly
                            ? 'Manager Remark Requested'
                            : prManagerRemarkNotifs.length > 0
                              ? 'Performance Reviews Pending'
                              : 'Performance Review Assigned'
                    }
                    visible={showPrReviewPopup}
                    onHide={() => dismissPrReviewPopup()}
                    style={{ width: '420px' }}
                    appendTo={typeof document !== 'undefined' ? document.body : null}
                    baseZIndex={12000}
                    modal
                    dismissableMask
                    footer={
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                label="Dismiss"
                                severity="secondary"
                                className="py-2 border-0"
                                onClick={() => dismissPrReviewPopup()}
                            />
                            <Button
                                label={prPopupIsManagerOnly ? 'Add Remark' : 'Open My Reviews'}
                                icon="pi pi-arrow-right"
                                className="py-2 border-0"
                                onClick={() => dismissPrReviewPopup({ openReviews: true })}
                                autoFocus
                            />
                        </div>
                    }
                >
                    <p className="mb-2">
                        {prPopupIsManagerOnly
                            ? `You have ${prManagerRemarkNotifs.length} report self-review${
                                  prManagerRemarkNotifs.length === 1 ? '' : 's'
                              } awaiting your manager remark.`
                            : prManagerRemarkNotifs.length > 0
                              ? `You have ${prSelfReviewNotifs.length} self-review${
                                    prSelfReviewNotifs.length === 1 ? '' : 's'
                                } to complete and ${prManagerRemarkNotifs.length} remark${
                                    prManagerRemarkNotifs.length === 1 ? '' : 's'
                                } to add.`
                              : `You have ${prSelfReviewNotifs.length} performance self-review${
                                    prSelfReviewNotifs.length === 1 ? '' : 's'
                                } waiting for you to complete.`}
                    </p>
                    <ul className="mb-0 ps-3">
                        {prPopupNotifications.slice(0, 5).map((n) => (
                            <li key={n.notification_id} className="mb-1">
                                {n.message}
                            </li>
                        ))}
                        {prPopupNotifications.length > 5 && (
                            <li className="text-muted">
                                +{prPopupNotifications.length - 5} more in Notifications
                            </li>
                        )}
                    </ul>
                </Dialog>

            </div>
        </div >

    );
};

export default Navbar;
